// extracted by mini-css-extract-plugin
export default {"center":"styles_center__muAgS","description":"styles_description__HVHqw"};